module.exports = __webpack_public_path__ + "548a4fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/favicon-32x32.png
// module id = 1515
// module chunks = 0